import React from 'react'
import Counter from './components/counter'

export default function App () {
  return (
       <Counter />
  )
};
